import React from 'react'
var QRCode = require('qrcode.react')

export default class Academicos extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="text-center m-5">
                    <QRCode
                        value={`http://www.crefito1app.com.br/${this.props.tipo}/${this.props.id}`}
                        size={128}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        renderAs={"svg"}
                    />
                    <b>Leia o QrCode ao lado para conferir a autenticidade do Relatório (usuário deve estar logado)</b>
                    <div className="mt-5 font-weight-bold">
                        O presente termo de visita será remetido, posteriormente, para o(s) e-mail(s) acima
                        informado do responsável pelo recebimento do ato fiscalizatório e/ou do responsável
                        técnico {this.props.profissao}, e/ou responsável administrativo do serviço.
                    </div>
                </div>
            </React.Fragment>
        )
    }
}